(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('weatherForecastPanel', WeatherForecastPanelDirective);

  function WeatherForecastPanelDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/propriedade/weather-forecast-panel.html',
      controller: 'WeatherForecastPanelCtrl',
      controllerAs: 'wf'
    };
  }
}());
